import { Space } from 'antd';
import cl from 'classnames';
import * as React from 'react';
import styled from 'styled-components';

import { BalloonToolbarProps } from '../../../slatePlugins/components/Toolbar/BalloonToolbar/BalloonToolbar.types';
import { ToolbarButtonProps } from '../../../slatePlugins/components/ToolbarButton/ToolbarButton.types';
import { colorsV2 } from '../../colors-v2';
import { Divider } from './Divider';
import { StyledToolbar } from './StyledToolbar';

const Wrapper = styled.div`
  background-color: ${colorsV2.white100};
  padding: 4px 8px;
  border: 1px solid ${colorsV2.gray20};
  border-radius: 8px;
  position: relative;
  top: -40px;
  .ant-space-align-center {
    .ant-space-item {
      display: flex;
      align-items: center;
    }
  }
`;

interface DefaultBalloonToolbarProps extends BalloonToolbarProps {
  hidden: boolean;
}

export const DefaultBalloonToolbar = ({
  hidden = false,
  className,
  children,
  theme = 'dark',
  arrow = false,
  icon,
}: DefaultBalloonToolbarProps & ToolbarButtonProps) => {
  return (
    <StyledToolbar
      className={cl(className, 'dol-balloon-toolbar')}
      $hidden={hidden}
      $theme={theme}
      $arrow={arrow}
    >
      <Wrapper>
        <Space>
          {icon}
          <Divider />
          {children}
        </Space>
      </Wrapper>
    </StyledToolbar>
  );
};
